/**
 * TibiMedia Customer API
 *
 * Contact: administratie@tibimedia.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrderPhase {

    Active = 'active',

    OnHold = 'on_hold',

    Completed = 'completed',

    Archived = 'archived'
}

